'use strict';

/* eslint no-undef: "off" */
/**
 * header wrapper
 */
define('headerWrapper',['headerQuick'], function (headerQuick) {
  return {
    template: '\n      <header>\n        <header-quick></header-quick>\n      </header>\n    ',
    components: {
      headerQuick: headerQuick
    }
  };
});
